export enum Theme {
  Dark = 'dark',
  Light = 'light',
  System = 'system',
}

export type ThemeModeSlice = {
  themeMode: Theme
  setThemeMode: (theme: Theme) => void
}

export enum Locale {
  English = 'en',
  Albanian = 'sq',
  Italian = 'it',
}

export type LocaleSlice = {
  locale: Locale
  setLocale: (locale: Locale) => void
}

export type IsStoreReadySlice = {
  isStoreReady: boolean
}

export type Store = ThemeModeSlice & LocaleSlice & IsStoreReadySlice

export type PersistedStore = Pick<ThemeModeSlice, 'themeMode'> & Pick<LocaleSlice, 'locale'>
